export const promotedGroupName = 'Recent';
export const filterResultGroupName = 'Result';
